import { render, staticRenderFns } from "./DependentDiplomaticVisa.vue?vue&type=template&id=4980c162&"
import script from "./DependentDiplomaticVisa.vue?vue&type=script&lang=js&"
export * from "./DependentDiplomaticVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports